export const AUTH_INFORMATION = 'authInformation'
